export default "__VITE_ASSET__DzZ1uX9P__"